import { render, staticRenderFns } from "./Mir.vue?vue&type=template&id=179d3d0b&scoped=true&"
import script from "./Mir.vue?vue&type=script&lang=js&"
export * from "./Mir.vue?vue&type=script&lang=js&"
import style0 from "./Mir.vue?vue&type=style&index=0&id=179d3d0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179d3d0b",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {TextWithIcon: require('/home/bitrix/frontend/components/other/TextWithIcon.vue').default,Button: require('/home/bitrix/frontend/components/other/Button.vue').default})
